// import React, {useState, useEffect} from 'react';
// import {
//   List,
//   ListItem,
//   ListItemText,
//   Divider,
// } from '@mui/material';
// import Collapse from '@mui/material/Collapse';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import {Link} from 'react-router-dom';
// import {EvaluarPermiso} from '../../Genericos/Generales';

// const Cuenta = props => {

//   const classes = props.classes;
//   const sesionUsuario = props.sesionUsuario;

//   useEffect (() => {
//     VerificarPermisos (
//       sesionUsuario.usuario.pantallasUsuario.listaPantallasRol
//     );
//   }, [sesionUsuario]);

//   const [cuenta, setCuenta] = useState (false);
//   const [perfil, setPerfil] = useState (false);
//   const [registrarUsuario, setRegistrarUsuario] = useState (false);

//   const [openCuenta, setOpenCuenta] = useState (false);
//   const handleOpenCuenta = () => {
//     setOpenCuenta (!openCuenta);
//   };

//   const VerificarPermisos = arrPermisos => {
//     setCuenta (EvaluarPermiso (arrPermisos, '/cuenta'));
//     setPerfil (EvaluarPermiso (arrPermisos, '/perfil'));
//     setRegistrarUsuario (EvaluarPermiso (arrPermisos, '/registrar'));
//   };

//   return (
//     <React.Fragment>
//       {cuenta
//         ? <ListItem onClick={handleOpenCuenta}>
//             <i className="material-icons">account_circle</i>
//             <ListItemText
//               classes={{primary: classes.listItemText}}
//               primary="Cuenta"
//             />
//             {openCuenta ? <ExpandLess /> : <ExpandMore />}
//           </ListItem>
//         : null}
//       <Collapse in={openCuenta} timeout="auto" unmountOnExit>
//         <List component="div" disablePadding>
//           {perfil
//             ? <ListItem
//                 component={Link}
//                 button
//                 to="/perfil"
//                 className={classes.listItemText}
//               >
//                 <i notranslate="true" className="material-icons">
//                   account_box
//                 </i>
//                 <ListItemText primary="Perfil" />
//               </ListItem>
//             : null}
//           {registrarUsuario
//             ? <ListItem
//                 component={Link}
//                 button
//                 to="/registrar"
//                 className={classes.listItemText}
//               >
//                 <i notranslate="true" className="material-icons">
//                   person_add
//                 </i>
//                 <ListItemText primary="Registrar Usuario" />
//               </ListItem>
//             : null}
//         </List>
//       </Collapse>
//       {cuenta ? <Divider /> : null}
//     </React.Fragment>
//   );
// };

// export default Cuenta;
import React, { useState, useEffect } from 'react';
import { List, ListItem, ListItemText, ListItemIcon, Collapse } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';
import { EvaluarPermiso } from '../../Genericos/Generales';
import { menuItemStyles } from '../../Tools/MenuItemStyles';

const Cuenta = ({ sesionUsuario }) => {
  const [cuenta, setCuenta] = useState(false);
  const [perfil, setPerfil] = useState(false);
  const [registrarUsuario, setRegistrarUsuario] = useState(false);
  const [openCuenta, setOpenCuenta] = useState(false);

  useEffect(() => {
    const permisos = sesionUsuario.usuario.pantallasUsuario.listaPantallasRol;
    setCuenta(EvaluarPermiso(permisos, '/cuenta'));
    setPerfil(EvaluarPermiso(permisos, '/perfil'));
    setRegistrarUsuario(EvaluarPermiso(permisos, '/registrar'));
  }, [sesionUsuario]);

  const handleOpenCuenta = () => {
    setOpenCuenta(!openCuenta);
  };

  return (
    <>
      {cuenta && (
        <>
          <ListItem
            button
            onClick={handleOpenCuenta}
            sx={menuItemStyles.expandableHeader}
          >
            <ListItemIcon sx={menuItemStyles.menuIcon}>
              <AccountCircleIcon />
            </ListItemIcon>
            <ListItemText
              primary="Cuenta"
              sx={menuItemStyles.menuText}
            />
            {openCuenta ? <ExpandLess /> : <ExpandMore />}
          </ListItem>

          <Collapse in={openCuenta} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {perfil && (
                <ListItem
                  button
                  component={Link}
                  to="/perfil"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <AccountBoxIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Perfil"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}

              {registrarUsuario && (
                <ListItem
                  button
                  component={Link}
                  to="/registrar"
                  sx={menuItemStyles.subMenuItem}
                >
                  <ListItemIcon sx={{ ...menuItemStyles.menuIcon, minWidth: 36 }}>
                    <PersonAddIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary="Registrar Usuario"
                    sx={menuItemStyles.subMenuText}
                  />
                </ListItem>
              )}
            </List>
          </Collapse>
        </>
      )}
    </>
  );
};

export default Cuenta;